import { lazy } from 'react';
import DashboardIcon from '@material-ui/icons/Dashboard';
import SettingsIcon from '@material-ui/icons/Settings';
import DescriptionIcon from '@material-ui/icons/Description';
import StorageIcon from '@material-ui/icons/Storage';
import TuneIcon from '@material-ui/icons/Tune';
import LabelIcon from '@material-ui/icons/Label';
import EventNoteIcon from '@material-ui/icons/EventNote';
import BarChartIcon from '@material-ui/icons/BarChart';
import PersonIcon from '@material-ui/icons/Person';

const EvidenceDashboardPage = lazy(() => import('../pages/EvidenceDashboardPage'));
const MyDashboardPage = lazy(() => import('../pages/MyDashboardPage'));
const EvidenceRecords = lazy(() => import('../pages/EvidenceRecords'));
const ApplicationSettings = lazy(() => import('../pages/ApplicationSettings'));
const CodeManagement = lazy(() => import('../pages/CodeManagement'));
const FieldRequirements = lazy(() => import('../pages/FieldRequirements'));
const CheckoutRequestList = lazy(() => import('../pages/CheckoutRequestList'));
const EvidenceDisposalPage = lazy(() => import('../pages/EvidenceDisposalPage'));
const EvidenceAuditPage = lazy(() => import('../pages/EvidenceAuditPage'));
const EvidenceAnalyticsPage = lazy(() => import('../pages/EvidenceAnalyticsPage'));

const evidenceMenus = [
  {
    id: 'myDashboard',
    label: 'My Dashboard',
    path: '/new-evidence/my-dashboard',
    icon: PersonIcon,
    component: MyDashboardPage,
    showInPreferences: true,
  },
  {
    id: 'evidenceDashboard',
    label: 'Evidence Dashboard',
    path: '/new-evidence/dashboard',
    icon: DashboardIcon,
    component: EvidenceDashboardPage,
    showInPreferences: true,
  },
  {
    id: 'records',
    label: 'Evidence Records',
    path: '/new-evidence/records',
    icon: DashboardIcon,
    component: EvidenceRecords,
    permissionLabel: 'Evidence Record',
    useAccessPermission: false,
  },
  {
    id: 'checkoutRequests',
    label: 'Checkout Requests',
    path: '/new-evidence/checkout-request',
    icon: DashboardIcon,
    component: CheckoutRequestList,
    permissionLabel: 'Check Out Requests',
    useAccessPermission: false,
  },
  {
    id: 'evidenceAudit',
    label: 'Evidence Audit',
    path: '/new-evidence/audit',
    icon: DashboardIcon,
    component: EvidenceAuditPage,
    permissionLabel: 'Evidence Audit',
    useAccessPermission: false,
  },
  {
    id: 'evidenceDisposal',
    label: 'Evidence Disposal',
    path: '/new-evidence/disposal',
    icon: DashboardIcon,
    component: EvidenceDisposalPage,
    permissionLabel: 'Manage Disposal Rules',
    useAccessPermission: true,
  },
  {
    id: 'evidenceAnalytics',
    label: 'Analytics',
    path: '/new-evidence/analytics',
    icon: BarChartIcon,
    component: EvidenceAnalyticsPage,
    showInPreferences: true,
  },
  {
    id: 'configuration',
    label: 'Configuration',
    icon: SettingsIcon,
    showInPreferences: false,
    children: [
      {
        id: 'application-settings',
        label: 'Application Settings',
        path: '/new-evidence/configuration/application-settings',
        icon: DescriptionIcon,
        component: ApplicationSettings,
      },
      {
        id: 'code-management',
        label: 'Code Management',
        path: '/new-evidence/configuration/code-management',
        icon: SettingsIcon,
        component: CodeManagement,
      },
      {
        id: 'database-advisor',
        label: 'Database Advisor',
        path: '/evidence/database-advisor',
        icon: StorageIcon,
      },
      {
        id: 'field-requirements',
        label: 'Field Requirements',
        path: '/new-evidence/configuration/field-requirements',
        icon: TuneIcon,
        component: FieldRequirements,
      },
      {
        id: 'select-labels',
        label: 'Select Labels',
        path: '/evidence/select-labels',
        icon: LabelIcon,
      },
      {
        id: 'scheduled-reports',
        label: 'Scheduled Reports',
        path: '/evidence/scheduled-reports',
        icon: EventNoteIcon,
      },
    ],
  },
];

export default evidenceMenus;
